(() => {
  'use strict';
  if (window.__cartSyncLoaded) return;
  window.__cartSyncLoaded = true;

  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const MIN_GAP_MS = 800;
  let running = false;
  let lastRun = 0;

  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  async function syncCart() {
    const now = Date.now();
    if (running || now - lastRun < MIN_GAP_MS) return;
    running = true;
    lastRun = now;

    try {
      const bust = `_=${now}`;
      const [cartRes, secRes] = await Promise.all([
        fetch(`${ROOT}cart.js?${bust}`, {
          cache: 'no-store',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        }),
        fetch(`${ROOT}?sections=cart-icon-bubble,cart-drawer&${bust}`, {
          cache: 'no-store',
          credentials: 'same-origin',
        }),
      ]);
      if (!cartRes.ok || !secRes.ok) return;

      const cart = await cartRes.json();
      const sections = await secRes.json();

      // Header cart icon: this theme duplicates the ID (desktop + mobile), so update every copy
      const bubble = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (bubble) {
        document.querySelectorAll('[id="cart-icon-bubble"]').forEach((el) => {
          el.innerHTML = bubble.innerHTML;
        });
      }

      // Cart drawer
      const drawer = document.querySelector('cart-drawer');
      const target = document.querySelector('#CartDrawer');
      const fresh = parse(sections['cart-drawer']).querySelector('#CartDrawer');
      if (drawer && target && fresh) {
        target.innerHTML = fresh.innerHTML;
        drawer.classList.toggle('is-empty', cart.item_count === 0);
        const overlay = target.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', () => drawer.close());
      }

      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
    } catch (err) {
      console.warn('[cart-sync]', err); // fail quietly, never force a reload loop
    } finally {
      running = false;
    }
  }

  const isBackForward = () => {
    const nav = performance.getEntriesByType('navigation')[0];
    return !!nav && nav.type === 'back_forward';
  };

  // Back/forward (bfcache or HTTP cache)
  window.addEventListener('pageshow', (e) => {
    if (e.persisted || isBackForward()) syncCart();
  });

  // Returning to the tab/app on mobile
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') syncCart();
  });
})();
